import { render } from "./SettingView.vue?vue&type=template&id=b4411382"
import script from "./SettingView.vue?vue&type=script&lang=js"
export * from "./SettingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__